/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingMicroserviceException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when missing requested microservice
 */
let MissingMicroserviceException = exports.MissingMicroserviceException = function (_Exception) {
  _inherits(MissingMicroserviceException, _Exception);

  /**
   * @param {String} microserviceIdentifier
   */
  function MissingMicroserviceException(microserviceIdentifier) {
    _classCallCheck(this, MissingMicroserviceException);

    return _possibleConstructorReturn(this, (MissingMicroserviceException.__proto__ || Object.getPrototypeOf(MissingMicroserviceException)).call(this, `Missing microservice ${microserviceIdentifier} in Kernel container`));
  }

  return MissingMicroserviceException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Exception/MissingMicroserviceException.js
// module id = 394
// module chunks = 0